export default {"src":"/_next/static/media/Pin, Location.f77e64eb.svg","height":20,"width":20};